import { isFalsy } from 'ramda-adjunct'

export const scrollToRef = (ref, context) =>
  !isFalsy(ref.current) &&
  !isFalsy(context.current) &&
  context.current.scroll({
    top: ref.current.offsetTop,
    behavior: 'smooth'
  })
